import { useCallback as l, useEffect as d, useLayoutEffect as a } from "react";
import m from "./index.es428.js";

var w = function w(_ref) {
  var r = _ref.setOpen,
      n = _ref.isOpen,
      t = _ref.target;
  var s = l(function (e) {
    if (e.code === "Escape") return r(!1);

    if (n && ["ArrowUp", "ArrowDown", "Tab"].includes(e.code)) {
      var _t$querySelectorAll;

      e.preventDefault();
      var o = Array.from((_t$querySelectorAll = t === null || t === void 0 ? void 0 : t.querySelectorAll(".".concat(m.listItemControl))) !== null && _t$querySelectorAll !== void 0 ? _t$querySelectorAll : []).filter(function (u) {
        return !u.hasAttribute("disabled");
      });
      if (!o.length) return;

      var i = o.indexOf(document.activeElement),
          c = function c() {
        var _o, _o$;

        i >= 0 ? (_o = o[(i + 1) % o.length]) === null || _o === void 0 ? void 0 : _o.focus() : (_o$ = o[0]) === null || _o$ === void 0 ? void 0 : _o$.focus();
      },
          f = function f() {
        var _o2, _o3;

        i === 0 ? (_o2 = o[o.length - 1]) === null || _o2 === void 0 ? void 0 : _o2.focus() : (_o3 = o[(i - 1) % o.length]) === null || _o3 === void 0 ? void 0 : _o3.focus();
      };

      if (e.code === "Tab") if (e.shiftKey) f();else return c();
      if (e.code === "ArrowDown") return c();
      e.code === "ArrowUp" && f();
    }
  }, [t, n]);
  d(function () {
    return t !== null && t !== void 0 && t.addEventListener("keydown", s), function () {
      t === null || t === void 0 ? void 0 : t.removeEventListener("keydown", s);
    };
  }, [s]);
},
    b = function b(_ref2) {
  var r = _ref2.isOpen,
      n = _ref2.popupRef,
      t = _ref2.onChangeOpenState,
      s = _ref2.isPopupPositionUnderVariable;
  a(function () {
    if (t !== null && t !== void 0 && t(r), r && n.current && !s) {
      var e = n.current;
      e.getBoundingClientRect().bottom > window.innerHeight && (e.style.top = "auto", e.style.bottom = "100%", e.style.marginBottom = "4px", e.style.marginTop = "0");
    }
  }, [r]);
};

export { w as useKeyboardNavigation, b as usePopupPosition };